import React, { useEffect, Suspense } from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // Correct import for jwtDecode


// Lazy loading the components
const DashboardNavbar = React.lazy(() => import('./DashboardNavbar'));
const Sidebar = React.lazy(() => import('./Sidebar'));
const UserManagement = React.lazy(() => import('./UserManagement'));
const CopyTrading = React.lazy(() => import('./CopyTrading'));
const Pricing = React.lazy(() => import('../utils/Pricing'));
const Referral = React.lazy(() => import('./Referral'));
const DashboardOverview = React.lazy(() => import('./DashboardOverview'));
const PositionTable = React.lazy(() => import('./PositionTable'));
const OrdersBook = React.lazy(() => import('./OrderBook'));
const Wallet = React.lazy(() => import('./Wallet'));

export default function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const logoutUser = () => {
      localStorage.removeItem('access_token');
      navigate('/auth/login');
    };

    const checkTokenExpiration = () => {
      const token = localStorage.getItem('access_token');
      if (!token) {
        logoutUser();
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Current time in seconds

        if (decodedToken.exp < currentTime) {
          // Token expired
          logoutUser();
        }
      } catch (error) {
        // Invalid token
        logoutUser();
      }
    };

    const token = localStorage.getItem('access_token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const timeUntilExpiration = decodedToken.exp * 1000 - Date.now();

        // Set a timeout to logout just before token expiration
        const timeoutId = setTimeout(() => {
          checkTokenExpiration();
        }, timeUntilExpiration);

        // Cleanup timeout on unmount
        return () => clearTimeout(timeoutId);
      } catch (error) {
        // If decoding fails, immediately logout
        logoutUser();
      }
    } else {
      // If no token, immediately logout
      logoutUser();
    }
  }, [navigate]);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Suspense wrapper around Sidebar and Navbar */}
      <Suspense fallback={<div>Loading Sidebar...</div>}>
        <Sidebar />
      </Suspense>
      <div className="flex-1 flex flex-col overflow-hidden">
        <Suspense fallback={<div>Loading Navbar...</div>}>
          <DashboardNavbar />
        </Suspense>
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200">
          <div className="container mx-auto px-6 py-8">
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                <Route path="/" element={<DashboardOverview />} />
                <Route path="user-management" element={<UserManagement />} />
                <Route path="copy-trading" element={<CopyTrading />} />
                <Route path="pricing" element={<Pricing />} />
                <Route path="/position-details" element={<PositionTable/>} />
                <Route path='/orders-book' element={<OrdersBook/>}/>
                <Route path="referral" element={<Referral />} />
                <Route path="wallet" element={<Wallet />} />
              </Routes>
            </Suspense>
          </div>
        </main>
      </div>
    </div>
  );
}
